<script lang="ts">
    // import src from './svg/more_vert_FILL0_wght400_GRAD0_opsz24.svg';
    import src from './svg/menu_FILL0_wght400_GRAD0_opsz24.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    export let scale: number = 1;
</script>

<TemplateIcon {src} {scale} alt="Menu" on:click />
